import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/auth.guard';
import { RoutePermissionResolver } from './@core/router/route-permission.resolver';
import { AuthenticationComponent } from './@core/auth/authentication/authentication.component';
import { NoInternetComponent } from './pages/nointernet/nointernet.component';
import { TermsAndConditionsComponent } from './documents/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './documents/privacy-policy/privacy-policy.component';
import { FingerprintRegistrationComponent } from './registration/fingerprint-registration/fingerprint-registration.component';
import { LEARegistrationComponent } from './registration/lea-registration/lea-registration.component';
import { LoginSectionComponent } from './app-login/login-section/login-section.component';
import { FeeAndPaymentComponent } from './my-application/fee-and-payment/fee-and-payment.component';
import { TimelineComponent } from './timeline/timeline.component';
import { ForgotPasswordEmailComponent } from './app-login/forgot-password-email/forgot-password-email.component';
import { ForgotPasswordPhoneComponent } from './app-login/forgot-password-phone/forgot-password-phone.component';
import { VerifyForgotPasswordComponent } from './app-login/verify-forgot-password/verify-forgot-password.component';
import { CaseFlowTimelineComponent } from './my-application/case-flow-timeline/case-flow-timeline.component';
import { RegistrationTemplateComponent } from './Queues/registration-template/registration-template.component';
import { EppRegistrationComponent } from './registration/epp-registration/epp-registration.component';
import { EppDashboardComponent } from './epp-dashboard/epp-dashboard.component';
import { ComplaintDownloadComponent } from './app-login/complaint-form/complaint-download/complaint-download.component';
import { ReceiptTemplateComponent } from './shared/components/receipt-template/receipt-template.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    data: {
      rootmodulenames: ['APP'],
      route: '/pages'
    },
    resolve: { permissions: RoutePermissionResolver }
  },
  {
    path: 'login',
    loadChildren: () => import('@core/auth/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('@core/auth/registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: 'reg-form',
    loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('@core/auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('@core/auth/change-password/change-password.module').then(m => m.ChangePasswordModule)
  },
  {
    path: 'manage-profile',
    loadChildren: () => import('./pages/manage-profile/manage-profile.module').then(m => m.ManageProfileModule)
  },
   {
    path: 'complaint-form',
    loadChildren: () => import('./app-login/complaint-form/complaint-form.module').then(m => m.ComplaintFormModule)
  },
  {
    path: 'authentication',
    component: AuthenticationComponent
  },
  {
    path: 'no-internet',
    component: NoInternetComponent
  },
  {
    path: 'app-login',
    loadChildren: () => import('./app-login/app-login.module').then(m => m.AppLoginModule)
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
      path: 'fingerprint-reg',
      component: FingerprintRegistrationComponent
  },
  {
      path: 'LEA-reg',
      component: LEARegistrationComponent
  },
  { path: 'login-new', component: LoginSectionComponent },
  {
      path: 'fee',
      component: FeeAndPaymentComponent
  },
  // { path: 'verify-identity', component: VerifyIdentityComponent },
  {
    path:'forgot-password-email',
    component:ForgotPasswordEmailComponent
  },
  {
    path: 'forgot-password-phone',
    component: ForgotPasswordPhoneComponent
  },
  {
    path:'verify-forgot-password',
    component:VerifyForgotPasswordComponent
  },
  {
      path: 'timeline',
      component: TimelineComponent
  },
 {
      path: 'case-flow-timeline',
      component: CaseFlowTimelineComponent
  },
   {
      path: 'epp-registration',
      component: EppRegistrationComponent
  },

  {
    path: 'app-download/:appId',
    component: RegistrationTemplateComponent,
  },
  {
    path: 'receipt-download/:receiptId',
    component: ReceiptTemplateComponent
  },
  {
    path: 'complaint-download/:complaintId',
    component: ComplaintDownloadComponent,
  },
  {
    path: 'license-builder',
    loadChildren: () => import('./decision-role-page/decision-role-page.module').then(m => m.DecisionRolePageModule)
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
  {path: 'epp-dashboard',component:EppDashboardComponent }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }